<template>
  <div class="context-panel">
    <div class="panel-header">
      <h3>Your Project</h3>
      <button
        v-if="problemId"
        @click="goToDetailedEdit"
        class="detail-button"
        title="Open detailed editor"
      >
        Open Editor
      </button>
    </div>

    <div class="context-sections">
      <div class="context-section" v-if="conversation.problem_statement">
        <label class="section-label">Problem</label>
        <div class="section-value">
          {{ conversation.problem_statement }}
        </div>
      </div>

      <div class="context-section" v-if="conversation.living_lab">
        <label class="section-label">Living Lab</label>
        <div class="section-value">
          {{ conversation.living_lab }}
        </div>
      </div>

      <div
        class="context-section"
        v-if="conversation.buildings && conversation.buildings.length"
      >
        <label class="section-label">Buildings</label>
        <div class="section-value">
          <div class="item-list">
            <div
              v-for="building in conversation.buildings"
              :key="building.id"
              class="item"
            >
              {{ building.name }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="context-section"
        v-if="conversation.stakeholders && conversation.stakeholders.length"
      >
        <label class="section-label">Stakeholders</label>
        <div class="section-value">
          <div class="item-list">
            <div
              v-for="stakeholder in conversation.stakeholders"
              :key="stakeholder.id"
              class="item"
            >
              {{ stakeholder.name }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="context-section"
        v-if="conversation.kpis && conversation.kpis.length"
      >
        <label class="section-label">KPIs</label>
        <div class="section-value">
          <div class="item-list">
            <div v-for="kpi in conversation.kpis" :key="kpi.id" class="item">
              {{ kpi.name }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="context-section"
        v-if="conversation.goals && conversation.goals.length"
      >
        <label class="section-label">Goals</label>
        <div class="section-value">
          <div class="item-list">
            <div v-for="goal in conversation.goals" :key="goal.id" class="item">
              {{ goal.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectContextPanel",
  props: {
    conversation: {
      type: Object,
      default: () => ({
        problem_statement: "",
        living_lab: "",
        buildings: [],
        stakeholders: [],
        kpis: [],
        goals: [],
      }),
    },
    problemId: {
      type: Number,
      default: null,
    },
  },
  methods: {
    goToDetailedEdit() {
      if (this.problemId) {
        this.$router.push(`/problem/${this.problemId}`);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.context-panel {
  max-width: 300px;
  padding: 16px;
  max-height: 70vh;
  overflow-y: auto;
  animation: slideInRight 0.4s ease-in-out;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--secondaryColorLight);
    border-radius: 3px;

    &:hover {
      background: var(--secondaryColor);
    }
  }
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid var(--secondaryColor);

  h3 {
    margin: 0;
    color: var(--primaryColor);
    font-size: 1.1rem;
  }
}

.detail-button {
  padding: 6px 10px;
  background-color: var(--primaryColor);
  color: var(--colorOnPrimary);
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: var(--primaryColorDark);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
}

.context-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}

.context-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.section-label {
  font-weight: 700;
  color: var(--primaryColor);
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.section-value {
  color: var(--darkColor);
  font-size: 0.9rem;
  line-height: 1.4;
  padding: 8px 10px;
  background-color: white;
  border-radius: 6px;
  word-break: break-word;
}

.item-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.item {
  padding: 6px;
  background-color: white;
  border-left: 3px solid var(--secondaryColor);
  padding-left: 10px;
  font-size: 0.85rem;
  color: var(--darkColor);
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Responsive: stack on mobile */
@media (max-width: 768px) {
  .context-panel {
    max-width: 100%;
    margin-bottom: 16px;
    max-height: none;
  }
}
</style>
